import axios from '@/plugins/axios.js';

export default {
    /**
     * Resolve current user access from the API rather than the login-time feature snapshot.
     */
    async check(featureName) {
        const { data } = await axios.get(`/api/features/${featureName}/access`);

        return data.granted;
    },
};
